import { render, staticRenderFns } from "./modal_edit_keyword.vue?vue&type=template&id=ab40aefc&scoped=true"
import script from "./modal_edit_keyword.vue?vue&type=script&lang=js"
export * from "./modal_edit_keyword.vue?vue&type=script&lang=js"
import style0 from "./modal_edit_keyword.vue?vue&type=style&index=0&id=ab40aefc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab40aefc",
  null
  
)

export default component.exports